// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function recordingId_encode(id) {
  return id;
}

function recordingId_decode(json) {
  var num = Js_json.decodeNumber(json);
  if (num !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: num | 0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "recordingId_decode error",
              value: json
            }
          };
  }
}

function playbackId_encode(tabId) {
  return tabId;
}

function playbackId_decode(json) {
  var num = Js_json.decodeNumber(json);
  if (num !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: num | 0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "playbackId_decode error",
              value: json
            }
          };
  }
}

function makeRecordingId(id) {
  return id;
}

function makePlaybackId(id) {
  return id;
}

function asInt(id) {
  return id;
}

function stringOfRecordingId(id) {
  return String(id);
}

function stringOfPlaybackId(id) {
  return String(id);
}

var TabId = {
  recordingId_encode: recordingId_encode,
  recordingId_decode: recordingId_decode,
  playbackId_encode: playbackId_encode,
  playbackId_decode: playbackId_decode,
  makeRecordingId: makeRecordingId,
  makePlaybackId: makePlaybackId,
  asInt: asInt,
  stringOfRecordingId: stringOfRecordingId,
  stringOfPlaybackId: stringOfPlaybackId
};

function recordingId_encode$1(id) {
  return id;
}

function recordingId_decode$1(json) {
  var num = Js_json.decodeNumber(json);
  if (num !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: num | 0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "recordingId_decode error",
              value: json
            }
          };
  }
}

function playbackId_encode$1(tabId) {
  return tabId;
}

function playbackId_decode$1(json) {
  var num = Js_json.decodeNumber(json);
  if (num !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: num | 0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "playbackId_decode error",
              value: json
            }
          };
  }
}

function makeRecordingId$1(id) {
  return id;
}

function makePlaybackId$1(id) {
  return id;
}

function asInt$1(id) {
  return id;
}

function stringOfRecordingId$1(id) {
  return String(id);
}

function stringOfPlaybackId$1(id) {
  return String(id);
}

var WindowId = {
  recordingId_encode: recordingId_encode$1,
  recordingId_decode: recordingId_decode$1,
  playbackId_encode: playbackId_encode$1,
  playbackId_decode: playbackId_decode$1,
  makeRecordingId: makeRecordingId$1,
  makePlaybackId: makePlaybackId$1,
  asInt: asInt$1,
  stringOfRecordingId: stringOfRecordingId$1,
  stringOfPlaybackId: stringOfPlaybackId$1
};

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "recordingId",
                v.recordingId
              ],
              [
                "playbackId",
                Decco.optionToJson(playbackId_encode, v.playbackId)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var recordingId = recordingId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingId"), null));
  if (recordingId.TAG === /* Ok */0) {
    var playbackId = Decco.optionFromJson(playbackId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackId"), null));
    if (playbackId.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                recordingId: recordingId._0,
                playbackId: playbackId._0
              }
            };
    }
    var e = playbackId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".playbackId" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = recordingId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".recordingId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function makeFromRecordingId(recordingId) {
  return {
          recordingId: recordingId,
          playbackId: undefined
        };
}

function assignPlaybackTabId(tabId, tabRef) {
  return {
          recordingId: tabRef.recordingId,
          playbackId: Caml_option.some(tabId)
        };
}

function equalsRecordingTabId(tabId, tabRef) {
  return Caml_obj.caml_equal(tabRef.recordingId, tabId);
}

function equalsPlaybackTabId(tabId, tabRef) {
  var playbackId = tabRef.playbackId;
  if (playbackId !== undefined) {
    return Caml_obj.caml_equal(Caml_option.valFromOption(playbackId), tabId);
  } else {
    return false;
  }
}

function getRecordingTabId(tabRef) {
  return tabRef.recordingId;
}

function getPlaybackTabId(tabRef) {
  return tabRef.playbackId;
}

function getPlaybackTabIdExn(tabRef) {
  var exnMessage = "Expected tab ref to have a playbackTabId";
  var playbackId = tabRef.playbackId;
  if (playbackId !== undefined) {
    return Caml_option.valFromOption(playbackId);
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError(exnMessage);
  }
}

function equalsTabRef(tabRefA, tabRefB) {
  return Caml_obj.caml_equal(tabRefA.recordingId, tabRefB.recordingId);
}

function stringify(param) {
  var recordingIdLabel = "recordingTabId";
  var playbackIdLabel = "playbackTabId";
  return "{" + (recordingIdLabel + ("=" + (String(param.recordingId) + (", " + (playbackIdLabel + ("=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.playbackId, stringOfPlaybackId)) + "}")))))));
}

var TabRef = {
  t_encode: t_encode,
  t_decode: t_decode,
  makeFromRecordingTabId: makeFromRecordingId,
  assignPlaybackTabId: assignPlaybackTabId,
  equalsTabRef: equalsTabRef,
  equalsRecordingTabId: equalsRecordingTabId,
  equalsPlaybackTabId: equalsPlaybackTabId,
  getRecordingTabId: getRecordingTabId,
  getPlaybackTabId: getPlaybackTabId,
  getPlaybackTabIdExn: getPlaybackTabIdExn,
  stringify: stringify
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "recordingId",
                v.recordingId
              ],
              [
                "playbackId",
                Decco.optionToJson(playbackId_encode$1, v.playbackId)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var recordingId = recordingId_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingId"), null));
  if (recordingId.TAG === /* Ok */0) {
    var playbackId = Decco.optionFromJson(playbackId_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackId"), null));
    if (playbackId.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                recordingId: recordingId._0,
                playbackId: playbackId._0
              }
            };
    }
    var e = playbackId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".playbackId" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = recordingId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".recordingId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function makeFromRecordingId$1(recordingId) {
  return {
          recordingId: recordingId,
          playbackId: undefined
        };
}

function assignPlaybackWindowId(windowId, windowRef) {
  return {
          recordingId: windowRef.recordingId,
          playbackId: Caml_option.some(windowId)
        };
}

function equalsRecordingWindowId(windowId, windowRef) {
  return Caml_obj.caml_equal(windowRef.recordingId, windowId);
}

function equalsPlaybackWindowId(windowId, windowRef) {
  var playbackId = windowRef.playbackId;
  if (playbackId !== undefined) {
    return Caml_obj.caml_equal(Caml_option.valFromOption(playbackId), windowId);
  } else {
    return false;
  }
}

function getRecordingWindowId(windowRef) {
  return windowRef.recordingId;
}

function getPlaybackWindowId(windowRef) {
  return windowRef.playbackId;
}

function getPlaybackWindowIdExn(windowRef) {
  var exnMessage = "Expected tab ref to have a playbackWindowId";
  var playbackId = windowRef.playbackId;
  if (playbackId !== undefined) {
    return Caml_option.valFromOption(playbackId);
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError(exnMessage);
  }
}

function stringify$1(param) {
  var recordingIdLabel = "recordingWindowId";
  var playbackIdLabel = "playbackWindowId";
  return "{" + (recordingIdLabel + ("=" + (String(param.recordingId) + (", " + (playbackIdLabel + ("=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.playbackId, stringOfPlaybackId$1)) + "}")))))));
}

var WindowRef = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  makeFromRecordingWindowId: makeFromRecordingId$1,
  assignPlaybackWindowId: assignPlaybackWindowId,
  equalsRecordingWindowId: equalsRecordingWindowId,
  equalsPlaybackWindowId: equalsPlaybackWindowId,
  getRecordingWindowId: getRecordingWindowId,
  getPlaybackWindowId: getPlaybackWindowId,
  getPlaybackWindowIdExn: getPlaybackWindowIdExn,
  stringify: stringify$1
};

exports.TabId = TabId;
exports.WindowId = WindowId;
exports.TabRef = TabRef;
exports.WindowRef = WindowRef;
/* Util-SmartcutsMacros Not a pure module */
